/**
 * TopBar — white h-14 bar: hamburger (drawer trigger under lg) + shop filter.
 */
import { Menu } from 'lucide-react';
import { ShopSelector } from './ShopSelector';

export function TopBar({ onMenuClick }: { onMenuClick?: () => void } = {}) {
  return (
    <header className="h-14 shrink-0 bg-white border-b border-gray-200 flex items-center gap-2 px-3 sm:px-6">
      <button
        type="button"
        onClick={onMenuClick}
        className="lg:hidden flex h-10 w-10 items-center justify-center rounded-md text-gray-600 hover:bg-gray-100"
        aria-label="Open navigation"
      >
        <Menu size={18} strokeWidth={2} aria-hidden />
      </button>
      <ShopSelector />
    </header>
  );
}
